import { useState, useEffect } from 'react';
import { FilesetResolver, FaceLandmarker } from '@mediapipe/tasks-vision';
import useIsMounted from '../../../../hooks/useIsMounted';

let sharedFaceLandmarker = null;
let sharedLoadingPromise = null;

export const useFaceLandmarker = () => {
  const [faceLandmarker, setFaceLandmarker] = useState(sharedFaceLandmarker);
  const [isLoading, setIsLoading] = useState(!sharedFaceLandmarker);
  const [error, setError] = useState(null);
  const isMounted = useIsMounted();

  useEffect(() => {
    if (sharedFaceLandmarker) {
      setFaceLandmarker(sharedFaceLandmarker);
      setIsLoading(false);
      return;
    }

    const initLandmarker = async () => {
      try {
        if (!sharedLoadingPromise) {
          sharedLoadingPromise = (async () => {
            const filesetResolver = await FilesetResolver.forVisionTasks(
              "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.15/wasm"
            );
            const landmarker = await FaceLandmarker.createFromOptions(filesetResolver, {
              baseOptions: {
                modelAssetPath: "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task",
                delegate: "GPU"
              },
              outputFaceBlendshapes: true,
              outputFacialTransformationMatrixes: true,
              runningMode: "VIDEO",
              numFaces: 2
            });
            return landmarker;
          })();
        }

        const landmarker = await sharedLoadingPromise;
        sharedFaceLandmarker = landmarker;

        if (isMounted.current) {
          setFaceLandmarker(landmarker);
          setIsLoading(false);
        }
      } catch (err) {
        console.error("Failed to initialize MediaPipe FaceLandmarker:", err);
        if (isMounted.current) {
          setError(err.message || "Failed to load face landmarker models.");
          setIsLoading(false);
        }
        sharedLoadingPromise = null; // Reset to allow retry
      }
    };

    initLandmarker();
  }, [isMounted]);

  return { faceLandmarker, isLoading, error };
};
